import appPromotions from "../../views/appSettings/promotions.html";
import constants from "../../core/constants";
import { getState } from "../../core/utils";

function urlsConfig($stateProvider) {
  "ngInject";

  const base = "promotions";
  const params = ["page", "limit", "sort", "segment", "date"];

  $stateProvider.state("promotions", {
    url: getState(base, params),
    parent: "app",
    views: {
      view: {
        template: appPromotions,
      },
    },
    reloadOnSearch: false,
    data: { title: "Promotions" + constants.titleBase },
  });
}

export default urlsConfig;



// WEBPACK FOOTER //
// ./src/pages/promotions/promotions.urls.js